import React, { useEffect, useState } from "react";
import { CheckSquare, ShoppingCart, Trash2, Lock } from "lucide-react";
import api from "../lib/api";
import { Card, PageHeader, PageLoader, Button } from "../lib/ui";
import { useToast } from "../lib/toast";
import { useAuth } from "../context/AuthContext";
import { useT } from "../lib/i18n";

export default function DailyClosing() {
  const { user } = useAuth();
  const toast = useToast();
  const { t } = useT();
  const [state, setState] = useState(null);

  const load = () => api.get("/daily-closing").then(({ data }) => setState(data));
  useEffect(() => { load(); }, []);
  if (!state) return <PageLoader />;

  const branchId = user.branch_id || state.branch_id;
  const toggle = (key) => setState((s) => ({ ...s, [key]: !s[key] }));

  const save = async () => {
    try {
      await api.post("/daily-closing", {
        branch_id: branchId, order_submitted: state.order_submitted,
        waste_submitted: state.waste_submitted, closing_completed: state.closing_completed,
      });
      toast.success(t("Daily closing saved"));
      load();
    } catch (e) { toast.error(e.response?.data?.detail || t("Failed")); }
  };

  const items = [
    { key: "order_submitted", label: "Order Submitted", desc: "Branch order for today has been submitted", icon: ShoppingCart },
    { key: "waste_submitted", label: "Waste Submitted", desc: "Today's waste has been reported", icon: Trash2 },
    { key: "closing_completed", label: "Daily Closing Completed", desc: "All end-of-day tasks finalized", icon: Lock },
  ];

  return (
    <div className="animate-fade-up mx-auto max-w-2xl">
      <PageHeader title={t("Daily Closing Checklist")} subtitle={`${state.date} · ${t("Confirm end-of-day tasks")}`} icon={CheckSquare} />
      <Card className="divide-y divide-line p-0">
        {items.map((it) => (
          <label key={it.key} className="flex cursor-pointer items-center gap-4 px-5 py-4 hover:bg-stone-50" data-testid={`closing-${it.key}`}>
            <input type="checkbox" checked={!!state[it.key]} onChange={() => toggle(it.key)} className="h-5 w-5 accent-primary" />
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-light text-primary"><it.icon size={20} /></div>
            <div className="flex-1">
              <p className="font-semibold text-ink">{t(it.label)}</p>
              <p className="text-xs text-ink-soft">{t(it.desc)}</p>
            </div>
          </label>
        ))}
      </Card>
      <div className="mt-4 flex justify-end">
        <Button onClick={save} data-testid="save-closing">{t("Save Checklist")}</Button>
      </div>
    </div>
  );
}
